import { Button, CircularProgress } from "@mui/material";
import grey from "@mui/material/colors/grey";
import { CustomEvent } from "schemas/functions";

interface IProps {
  isActive?: boolean;
  label: string;
  total?: number;
  handleChange: (e: CustomEvent) => void;
}

const styles = {
  mobileButton: {
    color: grey[500],
    fontSize: 12,
    textTransform: "none",
    borderRadius: 0,
    height: 50,
    minWidth: "100px",
  },
  mobileActive: {
    color: "white",
    borderBottom: "2px solid",
    borderColor: "secondary.light",
  },
};

const FavoriteListTabMobile = ({
  isActive,
  label,
  total,
  handleChange,
}: IProps) => {
  return (
    <Button
      onClick={handleChange}
      sx={[styles.mobileButton, isActive ? styles.mobileActive : {}]}
    >
      {label}{" "}
      {total === undefined || isNaN(total) ? (
        <CircularProgress size={10} color="secondary" sx={{ ml: 1 }} />
      ) : (
        `(${total})`
      )}
    </Button>
  );
};

export default FavoriteListTabMobile;
